import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {isEmpty} from 'front-onceforall-core/dist/utils/arrays';
import Invitation from './invitation';
import ExpandableList from '../expandableList';

function InvitationListView(props) {
  const loading = useSelector(globalState => globalState.notifications.isFetching);
  const invitationList = props.invitations.map((invitation, index) => (
    <Invitation
      isSuggestion={props.isSuggestion}
      key={`invitation-${index}`}
      invitation={invitation}
      onAccept={props.onAccept}
      onReject={props.onReject}
      canAddUser={props.canAddUser}
    />
  ));

  return (
    <div style={{position: 'relative'}}>
      {!isEmpty(invitationList) && loading && <div className="loading-overlay"/>}
      <div className="card-container-notifications">
        <ExpandableList
          items={invitationList}
          initialNumberOfItems={3}
          buttonLabel={props.isSuggestion ? 'invitation.suggestion.expandList' : 'invitation.received.expandList'}
        />
      </div>
    </div>
  );
}

InvitationListView.defaultProps = {
  isSuggestion: false
};

InvitationListView.propTypes = {
  invitations: PropTypes.array.isRequired,
  onAccept: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  canAddUser: PropTypes.bool,
  isSuggestion: PropTypes.bool
};

export default InvitationListView;
